import { Skeleton } from '@/components/ui/skeleton'

const RoomDetailsSkeleton: React.FC = () => {
  return (
    <div className='py-5 w-full space-y-6 px-24'>
      <div className='space-y-4'>
        <div className='flex items-center gap-4'>
          <Skeleton className='h-8 w-52' />
          <Skeleton className='h-7 w-6' />
          <Skeleton className='h-9 w-24 rounded-md' />
        </div>
        <Skeleton className='h-16 w-[42.1rem]' />
      </div>

      <div className='flex gap-4 mt-5'>
        <Skeleton className='h-10 w-36 rounded-md' />
        <Skeleton className='h-10 w-52 rounded-md' />
        <Skeleton className='h-10 w-52 rounded-md' />
      </div>

      <div className='mt-6 space-y-4'>
        <Skeleton className='h-8 w-40' />
        <div className='space-y-3'>
          <div className='flex items-center gap-4'>
            <Skeleton className='h-10 w-10 rounded-full' />
            <Skeleton className='h-5 w-40' />
          </div>
          <div className='flex items-center gap-4'>
            <Skeleton className='h-10 w-10 rounded-full' />
            <Skeleton className='h-5 w-36' />
          </div>
        </div>
      </div>

      <div className='mt-6 space-y-4'>
        <Skeleton className='h-8 w-48' />
        <Skeleton className='h-16 w-full max-w-lg' />
        <Skeleton className='h-10 w-48 rounded-md' />
      </div>

      <div className='mt-6 space-y-3'>
        <Skeleton className='h-8 w-64' />
        <div className='space-y-2'>
          <Skeleton className='h-32 w-full rounded-md' />
          <Skeleton className='h-32 w-full rounded-md' />
        </div>
      </div>
    </div>
  )
}

export default RoomDetailsSkeleton
